import {
  Component,
  Input,
  ViewChild,
  OnInit,
  OnChanges,
  SimpleChanges,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  DoCheck,
  OnDestroy,
  Renderer2,
  HostListener,
  EventEmitter,
  Output} from '@angular/core'
import { Question } from '../question/question.model'
import { Reply } from '../reply/reply.model'
import { QuestionService } from '../question/question.service'
import { ReplyService } from '../reply/reply.service'
import { ReplyComponent } from '../reply/reply.component'
import { AttachmentUploaderComponent } from '../shared/attachment-uploader/attachment-uploader.component'
import { ToastrService } from 'ngx-toastr'
import { TranslationService } from '../translation/translation.service'
import { AppState } from '../app.service'
import { Path } from '../path/path-v2.model'
import { Router } from '@angular/router'
import { Apollo } from 'apollo-angular'
import { CordovaService } from '../cordova.service'
import { I18n } from '../i18n.service'
import { SessionService } from '../session/session.service'
import { MobileChatServiceService } from '../pages/mobile-chat-board/mobile-chat-service.service'
import { RoutineV2Service } from '../routine-v2/routine-v2.service'
import { ToasterService } from '../toaster.service'
import { User } from '../user/user.model'
import { ModalController, Platform, PopoverController } from '@ionic/angular'
import { CommentListModalComponent } from '../comment-list-modal/comment-list-modal.component'
import { SpinnerService } from '../spinner.service'
import { HomeUiService } from '../new-design/home-ui.service';
import mixpanel from 'mixpanel-browser'
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx'
import { UserPublicProfileComponent } from '../components/user-public-profile/user-public-profile.component'
import { RoutineService } from '../daily-content-v2/routine.service'
import { TranslateComponentModalComponent } from '../components/translate-component-modal/translate-component-modal.component'
import { LANGUAGES } from '../components/translate-component-modal/translate.data'
import { animate, query, stagger, style, transition, trigger } from '@angular/animations'
import { DomSanitizer } from '@angular/platform-browser'
import { KyperDataApiService } from '../services/kyper-data-api.service'
import { InstepRepliesComponent } from '../instep-replies/instep-replies.component'
import { TranslateComponentModalService } from '../components/translate-component-modal/translate-component-modal.service'

@Component({
  selector: 'first90-question-v2',
  templateUrl: './question-v2.component.html',
  styleUrls: ['./question-v2.component.scss'],
    animations: [
      trigger('animateContent', [
        transition(':enter', [
          query(':scope > *', [
            style({ opacity: 0, transform: 'translateY(8px)' })
          ], { optional: true }),
  
          query(':scope > *', [
            stagger(100, [
              animate(
                '800ms cubic-bezier(0.76, 0, 0.24, 1)',
                style({ opacity: 1, transform: 'translateY(0)' })
              )
            ])
          ], { optional: true })
        ]),
  
        transition(':leave', [
          animate(
            '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
            style({ opacity: 0, transform: 'translateY(-75px)' })
          )
        ])
      ])
    ]
})
export class QuestionV2Component implements OnInit, OnChanges, AfterViewInit, DoCheck, OnDestroy {
  @Input() question
  @Input() mode: string = 'question'
  @Input() isPreview: boolean
  @Input() inverted: boolean = false
  @Input() small = false
  @Input() progressItems = []
  @Input() currentIndex = 0
  @Input() screenId;
  isTextboxHide = true;
  @ViewChild('questionTextRef') questionTextRef!: ElementRef;
  innerQuestionHtml: any;
  @ViewChild('uploader') uploader: AttachmentUploaderComponent
  @ViewChild('replyBlock') replyBlock: ElementRef
  @ViewChild('repliesContainer') repliesContainer: ElementRef
  @ViewChild("textareaForFeeds") txtarea_post: ElementRef;

  path: Path
  user: User
  ishideComment:boolean = true;
  sortBy: string = 'timestamp'
  replyText: string = ''
  cachedReplyText: string = ''  // LUMBA-1383
  attachmentUrl: string = null
  errors: { answerError: false }
  replyTo: Reply = null
  replyToComponent: InstepRepliesComponent
  replyToId: number
  isLoading: boolean = false
  replyOffset: number
  tagName_id: number
  view:any
  public replies: Reply[]
  public repliesTree: any[]=[]
  isTextAdded: boolean = false
  isMobileWebIos = false;
  isMobileWeb=false;
  modalDataResponse: any;
  page;
  apiReplyCount = 0;
  replyCount = 0;
  isMobile
  isKeyboardVisible=false
  selectedLanguage;
  private lastToggleState: boolean = false;
  availableLanguages = LANGUAGES;
  pathLanguage = 'en';
  userCommentedDate;
  recordsToShow;
  pathRegistration;
  @Input() hasScrollableContent = false;
  @Output() isQuestionCommentAdded = new EventEmitter<any>()
  constructor(
    private i18n: I18n,
    private apollo: Apollo,
    private router: Router,
    private appState: AppState,
    private toastrService: ToasterService,
    private questionService: QuestionService,
    private replyService: ReplyService,
    private translationService: TranslationService,
    private cordovaService: CordovaService,
    private sessionService: SessionService,
    private routineV2Service: RoutineV2Service,
    private mobileService: MobileChatServiceService,
    private cdRef: ChangeDetectorRef, // LUMBA-1325
    public modalCtrl: ModalController,
    private keyboard: Keyboard,
    private platform: Platform,
    private spinnerService: SpinnerService,
    public renderer: Renderer2,
    public homeUIService: HomeUiService,
    private routine: RoutineService,
    private kyperApiService: KyperDataApiService,
    private translateModalService: TranslateComponentModalService,
    public popoverController: PopoverController,
    private _sanitizer: DomSanitizer,
  ) {
    this.path = this.appState.get('currentPath')
    this.user = this.appState.get('currentUser')
    this.pathRegistration = this.appState.get('pathRegistration')
    this.page = 1
    //  this.getQuestionDetails();
    this.isMobile = this.appState.get('isMobile');
  }

  ngOnInit() {
    // LUMBA-1317
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    const persistedLang = this.appState.get('selectedLanguage');
    this.selectedLanguage = !!(persistedLang && persistedLang !== 'none');
    this.lastToggleState = this.selectedLanguage;
    console.log("this.appState.get(userlist)",this.appState.get("userlist"))
    //  this.repliesTree =  this.appState.get('questionReplies')??[]
    this.pathLanguage = this.path.language
    this.toggleSort('timestamp')
    this.appState.set("mode", "question"); //mode is set for particular SHARE YOUR THOUGHT
    this.platform.ready().then(() => {
     this.keyboard
        .onKeyboardWillShow()
        .subscribe(() => {
          this.isKeyboardVisible = true;
        });

     this.keyboard
        .onKeyboardWillHide()
        .subscribe(() => {
          this.isKeyboardVisible = false;
        });
    });
   // window.addEventListener('scroll', this.onScroll , true); //third parameter
  }
  toggleTheme() {
    this.homeUIService.toggleTheme();
    this.cdRef.detectChanges(); 
  }

  ngAfterViewInit() {
    this.userCommentedDate = this.question?.screen?.userResponse?.lastReplyDate
    if (this.screenId == 'daily-content-screen-question-comments' && this.repliesTree?.length ==0) {
      this.appState.set('isQuestionCompleted', null)
      this.getQuestionDetails();
    }

    this.replyOffset = this.replyBlock?.nativeElement?.offsetTop

    this.registerKeyboardEvents();
  }
   ngOnDestroy() {
    this.removeInputEventListeners();

  }

  addInputEventListeners() {
    const inputs = document.querySelector("textarea");
    if (inputs) {
       this.renderer.listen(inputs, "focus", () => {
         this.isKeyboardVisible = true;
       });

       this.renderer.listen(inputs, "blur", () => {
         this.isKeyboardVisible = false;
       });
       this.renderer.listen(inputs, "focusout", () => {
         this.isKeyboardVisible = false;
       });
    }
   
  }

  removeInputEventListeners() {
    const inputs = document.querySelector("textarea");
    if (inputs) {
       this.renderer.listen(inputs, "focus", null);
       this.renderer.listen(inputs, "blur", null);
       this.renderer.listen(inputs, "focusout", null);
    }
   
  }

  async ngDoCheck() {
    let isCommentDeleted = this.appState.get('refreshCommentList')  
    let isCommentAdded =  this.appState.get('isCommentAdded')  
    if (isCommentDeleted ||(isCommentAdded && this.screenId=='daily-content-screen-question-comments')) {
      this.page = 1;
      this.appState.set('isQuestionCompleted', null)
      this.appState.set('isCommentAdded', undefined)  
      this.appState.set('refreshCommentList', undefined)
      await this.getQuestionDetails(null, true);
    }
    // this.repliesTree =  this.appState.get('questionReplies')??[]
   // console.log(" this.repliesTree", this.repliesTree)
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['question']) {
      this.innerQuestionHtml = this._sanitizer.bypassSecurityTrustHtml(
        this.question?.screen?.content?.question ?? this.question?.screen?.content?.body ?? ''
      );
    }
    if (!changes.question || changes.question.firstChange) {
      return false
    }
    //  this.repliesTree =  this.appState.get('questionReplies')??[]
    // this.question.sortRepliesBy(this.sortBy)
    this.cdRef.detectChanges()
  }

  changeSubTextFont(): null {
    if (this.questionTextRef?.nativeElement) {
      this.applyStylesToAllInnerTags(this.questionTextRef.nativeElement);
    }
    return null;
  }

  applyStylesToAllInnerTags(element: HTMLElement) {
    if (!element) { return; }
    const childElements = Array.from(element.children);
    childElements.forEach((childElement: Element) => {
      const tagName = childElement.tagName.toLowerCase();
      if (tagName === 'ol' || tagName === 'ul') {
        this.renderer.setStyle(childElement, 'list-style', 'none');
        this.renderer.setStyle(childElement, 'padding-left', '1.5em');
      }
      if (tagName === 'li') {
        const dataList = childElement.getAttribute('data-list');
        const qlUi = childElement.querySelector('.ql-ui');
        if (qlUi) { this.renderer.setStyle(qlUi, 'display', 'none'); }
        if (dataList === 'bullet') {
          this.renderer.setStyle(childElement, 'list-style-type', 'disc');
          this.renderer.setStyle(childElement, 'display', 'list-item');
          this.renderer.setStyle(childElement, 'margin-left', '1em');
        } else if (dataList === 'ordered') {
          this.renderer.setStyle(childElement, 'list-style-type', 'decimal');
          this.renderer.setStyle(childElement, 'display', 'list-item');
          this.renderer.setStyle(childElement, 'margin-left', '1em');
        }
      }
      this.applyStylesToAllInnerTags(childElement as HTMLElement);
    });
  }

  toggleSort(by: string) {
    console.log("by:" + by);
    this.sortBy = by
    // this.question.sortRepliesBy(by)
  }

 HideComment(){
      this.ishideComment=false
  }

 ShowComment(){
      this.ishideComment=true
  }
  // orderingSubReplies(reply) {
  //   this.isTextboxHide = true;
  //   var level1 = [reply, ...this.repliesTree];
  //   let replySort;
  //   if (level1) {
  //     var subReply = level1.filter(item => item.rootId??item?.root_id)
  //     level1?.forEach(reply => {
  //       subReply?.forEach(element => {
  //        if (element.root_id=== reply.id|| element?.rootId === reply.id) {
  //          const updatedReply = { ...reply };
  //          if (!updatedReply.replies) {
  //             updatedReply.replies = [];
  //          }
  //           updatedReply.replies = [element, ...updatedReply.replies];
  //           updatedReply.timestamp = new Date(reply.createdAt);
  //           //replySort =updatedReply;
  //           const index = level1.findIndex(r => r.id === updatedReply.id);
  //           level1[index] = updatedReply;
  //         }
  //       });
  //     });
  //   // if (replySort) {
  //   //     replySort.timestamp = new Date(reply.createdAt);
  //   //   }
  //   //  let index =level1?.findIndex((reply) => reply.id == replySort.id)
  //   //   level1.splice(index,1)
  //     let repliesTree = level1.filter(reply => (reply.id??reply.annswerId) && (reply.replyLevel === 1 ))
  //     // this.repliesTree = [replySort, ...repliesTree];
  //     this.repliesTree = repliesTree;
  //     this.appState.set('questionReplies', this.repliesTree) 
  //     this.recordsToShow = this.repliesTree?.length
  //   }
  // }

  orderingSubReplies(newReply) {
  this.isTextboxHide = true;

  // Clone existing tree
  let level1Replies = [...this.repliesTree];

  // Find parent L1 reply
  const parentId = newReply.rootId ?? newReply.root_id;
  const parentIndex = level1Replies.findIndex(
    r => r.id === parentId
  );

  if (parentIndex === -1) return;

  // Clone parent reply
  const parentReply = { ...level1Replies[parentIndex] };

  // Ensure replies array
  parentReply.replies = parentReply.replies
    ? [newReply, ...parentReply.replies]
    : [newReply];

  // Update timestamp so latest activity is reflected
  parentReply.timestamp = new Date();

  level1Replies.splice(parentIndex, 1);

  level1Replies.unshift(parentReply);

  // Keep only L1 replies
  this.repliesTree = level1Replies.filter(
    r => r.replyLevel === 1
  );

  this.appState.set('questionReplies', this.repliesTree);
  this.recordsToShow = this.repliesTree.length;
}


  replyToComment() {
        if(this.replyTo) {

      mixpanel.track('share thoughts', {'thoughts': this.replyText})
    if(this.replyText.length==0){
      this.toastrService.error(this.i18n.t('Please enter a comment'))
      return false;
    }
    if(this.replyTo) {
      this.isTextboxHide =false;
     }
  let formatedText;
    var list_of_tags_ids = []

   this.isLoading = true
    list_of_tags_ids = this.sessionService.getUserTAGs(this.replyText, this.complexItems)
      list_of_tags_ids = list_of_tags_ids.filter(userId => userId !== this.user?.id)
         this.complexItems?.forEach(element => {
      const username = element.username.toString().trim();
      const formattedUsername = username
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
      const exactMention = `@${formattedUsername}`;
      const regex = new RegExp(`(?<!\\w)${exactMention}(?!\\w)`, 'g');
      if (regex.test(this.replyText)) {
        const replaceValue = `<span id="${element.id}"><strong id="${element.id}">${formattedUsername}</strong></span>`;
        formatedText = this.replyText.replace(regex, replaceValue);
      }
    });

    this.isLoading = true

    this.unloadReply()
    if (formatedText) {
      this.cachedReplyText = formatedText;
    }
    let userIdsToNotify = list_of_tags_ids?.length > 0 
      ? list_of_tags_ids 
      : (this.replyTo?.user?.id === this.user?.id ) 
        ? [] 
        : [this.replyTo?.user?.id];
    let input = {
        screen_content_id: this.question?.screenContentId,
        root_id: this.replyTo.id,
        reply_text: this.cachedReplyText,
        reply_type: 'question_sub_reply',
        reply_level: 2,
        user_ids: userIdsToNotify,
        comment_type:list_of_tags_ids?.length>0?'tag':'comment',
        is_translate: this.appState.get('selectedLanguage')? true:false
      }
      // } else {
      //     input = {
      //       screen_content_id: this.question?.screenContentId,
      //    reply_text: this.cachedReplyText,
      //    reply_type: 'question_reply',
      //    reply_level: 1
      //     }
      //   }
      
      this.kyperApiService.postKyperUserReplies(input).subscribe((reply) => {
        console.log('reply :', reply);
        if (this.replyTo) {
          this.appState.set('isSubReply', true)
          this.appState.set('isInstepReplyAnimationApplied', true);
        }
        // else {
        //   this.appState.set('isInstepAnimationApplied', true)
        //   this.userCommentedDate = new Date().toLocaleDateString(undefined, {
        //     year: 'numeric',
        //     month: 'long',
        //     day: 'numeric'
        //   });
        //   if (!this.question.screen.userResponse) {
        //     this.question.screen.userResponse = {}
        //   }
        //   this.question.screen.userResponse.lastReplyDate = this.userCommentedDate
        // }
        this.replyTo = null;
        this.replyToId = null
        this.ishideComment = true;
        this.reset();
        this.isLoading = false;
        this.isTextAdded = false;
        this.toastrService.success(
          this.i18n.t("Comment posted!")
        );
        this.loadReply();
        // Put the newly created sub-reply at the top of the tree
        try {
          this.orderingSubReplies(reply?.data ?? reply);
          this.replyCount = this.repliesTree?.length || this.replyCount;
        } catch (e) {
          // fallback: refresh from server if something unexpected
          this.getQuestionDetails(null, true);
        }
        this.isLoading = true;
        this.cdRef.detectChanges();
      }, (error) => {
        this.toastrService.error(
          this.i18n.t("Comment not posted. Check your connection and try reloading the app."));
        this.isLoading = false;
        // this.spinnerService.off()
        this.loadReply();
        this.cdRef.detectChanges();
      });
    }
    else {
      this.reply();
    }

  }


  reply() {
    mixpanel.track('share thoughts', {'thoughts': this.replyText})
    if(this.replyText.length==0){
      this.toastrService.error(this.i18n.t('Please enter a comment'))
      return false;
    }
    if(this.replyTo) {
      this.isTextboxHide =false;
     }
  let formatedText;
    var list_of_tags_ids = []

   this.isLoading = true
    list_of_tags_ids = this.sessionService.getUserTAGs(this.replyText, this.complexItems)
         this.complexItems?.forEach(element => {
      const username = element.username.toString().trim();
      const formattedUsername = username
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
      const exactMention = `@${formattedUsername}`;
      const regex = new RegExp(`(?<!\\w)${exactMention}(?!\\w)`, 'g');
      if (regex.test(this.replyText)) {
        const replaceValue = `<span id="${element.id}"><strong id="${element.id}">${formattedUsername}</strong></span>`;
        formatedText = this.replyText.replace(regex, replaceValue);
      }
    });

    this.isLoading = true

    this.unloadReply()
    if (formatedText) {
      this.cachedReplyText = formatedText;
    }
      let input = {
        step_id: this.question?.stepId,
        screen_id: this.question?.screenId,
        screen_content_id: this.question?.screenContentId,
        answer_text: this.cachedReplyText,
         is_translate: this.appState.get('selectedLanguage')? true:false,
         user_ids: list_of_tags_ids
      }
    this.kyperApiService.postKyperUserComment(input).subscribe((res) => {
        this.appState.set('isQuestionCompleted',null)
        this.appState.set('isInstepAnimationApplied', true)
        this.appState.set('isCommentAdded', true);
        this.isQuestionCommentAdded.emit()
        this.question.screen.isCompleted = true
        this.userCommentedDate = new Date().toLocaleDateString(undefined, {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
        if(!this.question.screen.userResponse)
          {
            this.question.screen.userResponse ={}
          }
          this.question.screen.userResponse.lastReplyDate = this.userCommentedDate
        // Persist into DailyStepsData + currentPath so completion survives an in-step
        // close/reopen (which re-derives step data from currentPath) without a refresh.
        this.appState.persistScreenContent(
          { isCompleted: true, userResponse: this.question.screen.userResponse },
          { screenContentId: this.question?.screenContentId }
        )
        this.ishideComment = true;
        this.replyTo = null;
          this.replyToId = null;
        this.reset();
        // this.getQuestionDetails();
        this.isLoading = false;
        this.isTextAdded = false;
        this.toastrService.success(
          this.i18n.t("Comment posted!")
        );
        this.loadReply();
        // // Prepend the newly created top-level comment so it appears at the top
        // try {
        //   this.orderingSubReplies(res?.data ?? res);
        //   this.replyCount = this.repliesTree?.length || this.replyCount;
        // } catch (e) {
        //   // fallback: refresh the list from server
        //   this.getQuestionDetails(null, true);
        // }
        this.isLoading = true;
        this.cdRef.detectChanges();
      }, (error) => {
        this.toastrService.error(
              this.i18n.t("Comment not posted. Check your connection and try reloading the app."));
            this.isLoading = false;
            // this.spinnerService.off()
            this.loadReply();
            this.cdRef.detectChanges();
      })
    

    SessionService.setData(0)

  }

  translate(lang) {
    // let toggleEnabled = $event.detail.checked
    // console.log('toggleEnabled :', toggleEnabled);

    // if (toggleEnabled === true) {
    console.log('repliesTree before translation:', this.repliesTree);
    const path: Path = this.appState.get("currentPath");
    // const repliesIds = this.repliesTree.map((reply) => reply.id);
    if (this.repliesTree?.length <= 0) return;
    const repliesIds = this.repliesTree?.reduce((acc, item) => {
      acc.push(item.id);
      if (item.replies?.length) {
        acc.push(...item.replies.map(r => r.id));
      }
      return acc;
    }, []);
    this.translationService
      .loadRepliesTranslations(repliesIds, lang)
      .subscribe((translations) => {
        // this.repliesTree.forEach((reply) => {
        //   const key = `Reply:${reply.id}`;
        //   reply.text = translations[key].text;
        //   this.cdRef.detectChanges()
        // });
        // this.repliesTree.forEach(reply => {
        //   const key = `Reply:${reply.id}`;
        //   Object.isFrozen(reply) ? { ...reply } : reply;
        //   reply.text = translations[key].text;
        //   reply?.replies?.forEach(element => {
        //     if (element.repliableId === reply.id) {
        //       const key = `Reply:${element.id}`;
        //       element.text = translations[key].text;
        //       this.cdRef.detectChanges()
        //     }
        //   });
        // });
        this.repliesTree = this.repliesTree.map(reply => {
          const key = `Reply:${reply.id}`;
          const translatedReply = Object.isFrozen(reply)
            ? { ...reply, replyText: translations[key]?.text }
            : { ...reply, replyText: translations[key]?.text };

          // If replies array exists, clone and update each one
          const updatedReplies = reply.replies?.map(element => {
            const innerKey = `Reply:${element.id}`;
            return {
              ...element,
              replyText: translations[innerKey]?.text || element.replyText
            };
          });

          return {
            ...translatedReply,
            replies: updatedReplies || []
          };
        });
        this.appState.set('questionReplies', this.repliesTree) 
        this.cdRef.detectChanges();
        this.appState.set("feeds_list", null);
        this.appState.set("isNewLanguageSelected", true)
      });
    // }

    // if (toggleEnabled === false) {
    //   this.appState.set('commentDeleted', true)
    //   this.cdRef.detectChanges()
    // }
  }

  reset() {
    this.replyText = ''
    this.attachmentUrl = null
    if (this.uploader) {
      this.uploader.reset()
    }
    this.cachedReplyText = ''
  }

  // LUMBA-1383
  loadReply() {
    if (this.cachedReplyText) {
      this.replyText = this.cachedReplyText
      this.cachedReplyText = ''
    }
  }

  // LUMBA-1383
  unloadReply() {
    this.cachedReplyText = this.replyText
    this.replyText = ''
  }

  setReplyTo(replyComponent: InstepRepliesComponent) {
    if (this.uploader) {
      this.uploader.reset()
    }
    // This code was needed when all replies was visible
    // Now all replies hidden except selected for reply
    if (this.replyToComponent) {
      this.replyToComponent.selected = false
    }
    if(replyComponent?.selected){
      this.txtarea_post?.nativeElement.focus();
    }
    this.replyToComponent = replyComponent
    if (replyComponent) {
      this.replyTo = replyComponent.reply
      this.replyToId = this.replyTo.id
    } else {
      this.replyTo = null
      this.replyToId = null
    }
  }

  backToComent() {
    this.replyTo = null
    this.replyToId = null
    this.replyToComponent.selected = false
    this.reset();
  }

  // Remove a reply locally when a child emits that it was deleted on server
  onReplyDeleted(id: number) {
    if (!id) return
    // Immutable update so Angular picks up change
    this.repliesTree = (this.repliesTree || []).filter(r => r?.id !== id)
    this.replyCount = this.repliesTree?.length || 0

    if (this.replyToId === id) {
      this.replyTo = null
      this.replyToId = null
      this.replyToComponent = null
    }

    // Ensure view updates
    try { this.cdRef.detectChanges() } catch (e) { try { this.cdRef.markForCheck() } catch(_) {} }
  }

  // Handle nested comment deletion emitted from `instep-replies` child
  onCommentChildDeleted(event: { replyId: number, commentId: number }) {
    if (!event || !event.replyId || !event.commentId) return
    try {
      // Update local repliesTree immutably
      this.repliesTree = (this.repliesTree || []).map(r => {
        if (r?.id === event.replyId) {
          const newReplies = (r.replies || []).filter(c => c?.id !== event.commentId)
          return { ...r, replies: newReplies }
        }
        return r
      })
      this.replyCount = this.repliesTree?.length || 0
      this.cdRef.detectChanges()
    } catch (e) {
      try { this.cdRef.markForCheck() } catch(_) {}
    }
  }

  refresh() {
    this.apollo.getClient().clearStore()
    this.appState.refreshMainComponent.emit()
  }

  onTextChange(event) {
    if (event?.trim()?.length > 0)
    {
      this.isTextAdded = true
    }
    else {
      this.isTextAdded = false;
    }
  }
  scrollTo(event) {
    if (this.cordovaService.onCordova) {
      setTimeout(() => {
        window.scrollTo({top: this.replyBlock?.nativeElement?.offsetTop - 160, behavior: 'smooth'})
      }, 10)
    }
  }

  complexItems = this.appState.get("userlist")

  namesData : any[]

  format(item:any) {
    var data = item['id']
    setTimeout(() => {
      SessionService.setData(data)
    }, 100);
    const username = item['username'].toString();
    const formattedUsername = username
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    return `@${formattedUsername}`;
  }

  mentionConfig:any = {
    mentions: [
      {
        items: this.complexItems,
        labelKey: 'username',
        mentionSelect: this.format,
        dropUp:true
      }
    ]
  };

  translatePost(language: string,text: any){

    let data = {
      language: language,
      text: text
    }

    this.mobileService.translateContent(data).subscribe(
      (response) => {
        if(response.status){
          this.replyText = response.data.text
          this.cdRef.detectChanges()
          this.toastrService.success(this.i18n.t('Post translated successfully!'))
        }
      },
    (error) => {
      this.toastrService.error(this.i18n.t('Text translation failed!'))
      console.log("TranslationService data ",error);
    }
    )
  }
  isKeyboardOpened(ev) {
    if (this.isMobile) {
      this.isKeyboardVisible = true;
    }    
  }
  doInfinite(event) {
    console.log('doInfinite :');
    this.getQuestionDetails(event);
  }
  async openTranslateModal(ev: any) {
    // this.selectedLanguage = ev.detail.checked
    const checked = ev.detail.checked;
    if (checked === this.lastToggleState) {
      return;
    }
    this.lastToggleState = checked;
    if (checked) {
      const modal = await this.modalCtrl.create({
        component: TranslateComponentModalComponent,
        componentProps: {
          languages: this.availableLanguages.filter(([code]) => code !== this.pathLanguage),
          pathLanguage: this.availableLanguages.find(([code]) => code === this.pathLanguage)
        },
        cssClass: this.isMobile ? 'mobile-custom-to_do_list-forms mobile_language_translate_modal' : 'web_feedbackForm_modal',
        animated: false
      });
      modal.onDidDismiss().then((result) => {
        if (result.role === 'backdrop') {
          this.selectedLanguage = false;
          this.lastToggleState = false;
          mixpanel.track("User closed the modal by clicking on backdrop before saving language");
        } else if (result.data) {
         
          const selected = this.appState.get("selectedLanguage");
          if (this.selectedLanguage != selected) {
            // this.selectedLanguage = this.appState.get("selectedLanguage") ? true : false;
            // this.lastToggleState = !!this.selectedLanguage;
            const persistedLang = this.appState.get('selectedLanguage');
            this.selectedLanguage = !!(persistedLang && persistedLang !== 'none');
            this.lastToggleState = this.selectedLanguage;
            this.translate(selected)
          }
        }
        else {
          this.selectedLanguage =false
          this.lastToggleState = false;
          mixpanel.track("User closed the modal without selecting any language by clicking close");
        }
      });
      await modal.present();
    }
    else {
      // this.appState.set("selectedLanguage", 'none');
      this.selectedLanguage = false;
      this.lastToggleState = false;
      this.confirm('none')
       
    }
  }

  isNoteEnabled() {
    const loggedInUserReplies = this.repliesTree?.filter(reply => reply?.user?.id === this.user?.id) ?? [];
    return (this.repliesTree?.length ?? 0) < 3 && (this.replyCount ?? 0) < 3;
  }
  confirm(lang) {
    this.translateModalService.saveTranslateLang(lang).subscribe((res) => {
      this.appState.set("selectedLanguage", res?.user_language);
      let updateUser = this.appState.get('currentUser')
      updateUser.userLanguage = res?.user_language;
      // this.selectedLanguage = this.appState.get("selectedLanguage") ? true : false;
      // this.lastToggleState = !!this.selectedLanguage;
      const persistedLang = this.appState.get('selectedLanguage');
      this.selectedLanguage = !!(persistedLang && persistedLang !== 'none');
      this.lastToggleState = this.selectedLanguage;
      this.appState.set("currentUser", updateUser);
      this.translate('none')
      mixpanel.track("user disabled translation by clicking on off", { Language: res?.user_language, selectedLang: 'none' })
    }, (err) => {
      mixpanel.track("Error while storing language", { error: err })
      this.toastrService.error(this.i18n.t("Error while saving language, pls try again"))
    })
  }
  async getQuestionDetails(event=null,isPostDeleted=false): Promise<any>{
    return new Promise( async (resolve, reject) => {
    try{
      const data = {
        screenContentId: this.question?.screenContentId,
        path_id: this.path.id,
        page: this.page
      }

      await this.routineV2Service.getKyperPostRepliyDetailsById(data).subscribe(
        (response) => {
          let res = response?.replies?.length > 0 ? response?.replies[0] : []
          this.appState.set('isQuestionCompleted', true)
            var level1;
             if(this.page ==1 || isPostDeleted) {
                this.apiReplyCount = 0;
               this.repliesTree = [];
             }
            if (this.page == 1 && res?.userAnswers?.length > 0) {
              this.repliesTree = [];
              level1 = res?.userAnswers;
            }
            else if (res?.userAnswers?.length > 0) {
              level1 = this.repliesTree.concat(res?.userAnswers);
            }
          this.replyCount = res.replyCount;
          this.userCommentedDate = res?.lastReplyDate?? this.userCommentedDate;
           this.apiReplyCount = this.apiReplyCount + res?.userAnswers?.length;
          if (level1) {
            var subReply = level1.filter(item => item.repliableId)
              
            level1.forEach(reply => {
              subReply.forEach(element => {
                if (element.repliableId === reply.id) {
                  reply.replies.push(element)
                }
                reply.timestamp = new Date(reply.createdAt)
              });
            }); 
            this.repliesTree = level1.filter(reply => reply.id && reply.replyLevel === 1)
            // if (this.page == 1) {
            //   this.repliesTree= this.repliesTree.concat(repliesTree)
            // }
            // else {
            //    this.repliesTree= this.repliesTree.concat(repliesTree);
            // }
            if (this.repliesTree?.length > 3 && !this.recordsToShow) {
              this.recordsToShow = 3;
      
              // this.renderer.addClass(this.repliesContainer?.nativeElement, 'hide_comment');
            }
            else {
              this.recordsToShow =this.repliesTree?.length
            }
            this.page = this.page + 1
            if (event) {
              event.target.complete();
            }
             this.cdRef.detectChanges();
            console.log("repliescount", this.repliesTree)
            this.appState.set('questionReplies', this.repliesTree) 
            this.appState.set('repliesLength', this.repliesTree.length)
            this.cdRef.detectChanges();
        }
       
      },

       (error) => {
        console.log('error',error)
        this.toastrService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
      }
      )
      resolve(true);
    }catch (error){
      console.log('error',error)
      reject(error);
        this.toastrService.error(this.i18n.t("Server or connection issue. Please check your internet connection."))
    }
  });
  } 

  showRecords() {
   let count = this.repliesTree?.length-this.recordsToShow;
   if(count>0) {
     this.recordsToShow = this.repliesTree?.length;
      // this.renderer.removeClass(this.repliesContainer?.nativeElement, 'hide_comment');
   }
   
  }

  capitalizefirstletter(word: string){
    return word.charAt(0).toUpperCase() + word.slice(1)
  }

  async initModal() {
    var id = this.question.id
    this.appState.set('question',this.question)
    const modal = await this.modalCtrl.create({
      component: CommentListModalComponent,
      componentProps: {
        question: this.question.id
      }
    });

    modal.onDidDismiss().then((modalDataResponse) => {
      if (modalDataResponse !== null) {
        this.modalDataResponse = modalDataResponse.data;
      }
    });

    return await modal.present();
  }
  @HostListener('click', ['$event'])
  onLinkClick(e) {
    if (this.platform.is('mobileweb')) {
       this.addInputEventListeners();
    }
  if(e.target.tagName.toLowerCase() === 'span' || e.target.tagName.toLowerCase()=='strong'){
       console.log('target id', e.target.id);
       console.log("e.target.id", e, e.target.id);
       if (e?.target?.id || e.target?.parentElement.id) {
         this.getUserData(e, e.target.id? e.target.id: e.target?.parentElement.id);
       }
     }

     this.registerKeyboardEvents();
   }

   getUserData(event, id){
     this.routine.getUserDetailsById(id).subscribe(value=>{
       console.log('userid....', value);
       this.openuserInfo(event, value.data[0]);
     });
   }
   async openuserInfo(ev, userData): Promise<void> {
     const popover = await this.popoverController.create({
       component: UserPublicProfileComponent,
       event: ev,
       mode:'ios',
       translucent: false,
       componentProps: {'user': userData}
     });
     await popover.present();
    
   }

   registerKeyboardEvents() {
      if (!(this.platform.is('cordova') || this.platform.is('ios') || this.platform.is('android'))) {
        return;
      }

      this.keyboard.onKeyboardDidShow().subscribe((info) => {
        this.moveTextareaUp(info.keyboardHeight);
      });

      this.keyboard.onKeyboardWillHide().subscribe(() => {
        this.resetTextarea();
      });
    }

    moveTextareaUp(keyboardHeight: number) {

      // let offset = 0;
      // if (!this.replyBlock) return;
      // if (this.platform.is('android') && !this.platform.is('mobileweb')) {
      //    offset = keyboardHeight - 75;
      // }
      // else if (this.platform.is('ios')) {
      //   offset = keyboardHeight - 20;
      // }

      // this.replyBlock.nativeElement.style.bottom = `${offset}px`;
      const element = document.querySelector( '.input-group.comment-textarea' );
      if(this.platform.is('ios')){
        // element?.setAttribute('style', `height:50px; bottom: calc(${keyboardHeight}px - 110px);`);
        // element?.setAttribute('style', `height: calc(100vh - ${keyboardHeight}px); background: transparent; box-shadow: unset; border: 0`);
        element?.setAttribute('style', `bottom: calc(${keyboardHeight}px - 8px); `);
      }else{
        if(keyboardHeight <271){
          keyboardHeight = keyboardHeight+(271-keyboardHeight);
        }
        else {
          keyboardHeight = keyboardHeight+2;
        }
        element?.setAttribute('style', `bottom: ${keyboardHeight}px; `);
      }
    }

    resetTextarea() {
      // if (!this.replyBlock) return;

      // this.replyBlock.nativeElement.style.bottom = '0px';
        const element = document.querySelector( '.input-group.comment-textarea' ) ;
        element?.setAttribute('style', `height: auto`)
    }

    adjustForKeyboard(isKeyboardVisible: boolean, info: any) {
      if (!(this.platform.is('cordova') || this.platform.is('ios') || this.platform.is('android'))) {
        return;
      }


      const element = document.querySelector(
        '.input-group.comment-textarea'
      ) as HTMLElement;

      if (!element) return;

      if (isKeyboardVisible && info?.keyboardHeight) {
        element.style.bottom = `calc(${info.keyboardHeight}px - 20px)`;
      } else {
        element.style.bottom = '0px';
      }
    }
  @HostListener('touchend', ['$event'])
  onTouchEnd(event: TouchEvent) {
    if (this.platform.is("mobileweb")) {
      this.addInputEventListeners();
    }
  }
}
